export const hasItems = (
  requiredItems: string[] = [],
  availableItems: string[] = [],
  matchAll: boolean = false
): boolean => {
  if (matchAll) {
    return requiredItems.every(isIn(availableItems));
  } else {
    return requiredItems.some(isIn(availableItems));
  }
};

const isIn = (array: string[]) => (requiredItem: string) => array.includes(requiredItem);
